import {
  ApiService,
  ParentModel,
  requestHelper,
  type AuthService,
  type ServiceStore,
} from '@blueprint/frontend-basics'

import { TaleDto } from '@/models/dtos/tale.dto.ts'

export class TaleService extends ApiService {
  private readonly backendURL: string

  constructor(
    serviceStore: ServiceStore,
    authService: AuthService,
    backendURL: string,
  ) {
    super(serviceStore, authService)
    this.backendURL = backendURL
  }

  public async createTale(taleData: TaleDto): Promise<TaleDto> {
    const headers = await this.getAuthHeaders()
    const response = await requestHelper.post(
      `${this.backendURL}/tale`,
      taleData,
      { headers },
    )
    return ParentModel.fromJson(response.data, TaleDto)
  }
}
